export const HTTP_HEADERS = {
  TENANT_ID: 'Tenant-Id',
} as const;
